import { Cable } from '@mui/icons-material';
import { StoryousIntegrationPage } from '../modules/storyous-integration';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const StoryousIntegration: RouteType = {
  exact: true,
  icon: Cable,
  path: routePaths.storyousIntegration,
  title: 'Storyous',
  component: () => <StoryousIntegrationPage />,
  permission: 'canConnectStoryousIntegration',
};

export default StoryousIntegration;
